export const en = {
    'invite-call-link-title': 'Link to join the call',
    'invite-call-link-hint': 'You can send this link to anyone, including non-Yandex employees. When the call is created, the participant can use this link to join the call via the browser',
    'invite-call-link-copy-success': 'The link to join the call was copied',
    'copy-invite-call-link-title': 'Copy the link',
    'regenerate-invite-call-link': 'Regenerate the link',
}
